import { UILobbyTableController } from './UILobbyTableController.ts';
import { notificationController } from '../../EntryShared.ts';
import { LobbyImage } from '@colonist/types';
import { setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { createGloballyExclusiveHandler } from '../../ui_utils/ClientUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ClientUserState } from '../../ClientUserState.ts';
import { SocketLobbySend } from '../../socket/SocketLobbySend.ts';
import { RoomType } from '@colonist/lobby-types';
import { showJoinRoomDialog } from '../../ui_popup/join_room_dialog/showJoinRoomDialog.ts';
export class UILobbyController {
    setupButtonHandlers() {
        if (this.createRoomButton) {
            setElementOnClick(this.createRoomButton, createGloballyExclusiveHandler(async ()=>{
                AudioManager.play(AudioType.JoinRoom);
                await ClientUserState.requireUser();
                SocketLobbySend.clickedCreateRoom(RoomType.Standard, false);
            }));
        }
        setElementOnClick(this.joinRoomButton, createGloballyExclusiveHandler(()=>{
            this.openJoinRoomPopup();
        }));
    }
    // eslint-disable-next-line class-methods-use-this
    async handleJoinRoom(roomId) {
        await SocketLobbySend.accessGameFromLink(roomId);
    }
    openJoinRoomPopup() {
        showJoinRoomDialog({
            onJoin: (roomId)=>void this.handleJoinRoom(roomId)
        });
    }
    hide() {
        this.lobbyContainerDiv.style.display = 'none';
        this.tableController.hide();
    }
    show() {
        this.lobbyContainerDiv.style.display = 'flex';
        this.tableController.show();
    }
    updateRoomList(data) {
        this.tableController.updateRoomList(data);
    }
    onGotKicked(roomId, canRejoin) {
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.youWereKickedFromRoom'
        });
        this.tableController.onGotKicked(roomId, canRejoin);
    }
    constructor(){
        this.tableController = new UILobbyTableController();
        this.lobbyContainerDiv = document.getElementById('scene_lobby_mid');
        this.createRoomButton = document.getElementById('m-lobby-create-room-btn');
        this.joinRoomButton = document.getElementById('m-lobby-join-room-btn');
        this.setupButtonHandlers();
    }
}
